import { render, staticRenderFns } from "./PortalSite.vue?vue&type=template&id=ef871374&scoped=true"
import script from "./PortalSite.vue?vue&type=script&lang=js"
export * from "./PortalSite.vue?vue&type=script&lang=js"
import style0 from "./PortalSite.vue?vue&type=style&index=0&id=ef871374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef871374",
  null
  
)

export default component.exports